import React, { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import "./Remote.css";
import EquipmentButtonIcons from "../../constants/EquipmentButtonIcon";
import {
  DeleteEquipmentButton,
  DeleteEquipments,
  UpdateEquipmentButton,
  UpdateEquipments,
} from "../../api/api";
import { Link, useNavigate, useParams } from "react-router-dom";
import SuccessToast from "../toasts/SuccessToast";
import { MqttContext } from "../../context/MQTTContext";
import WarningAlert from "../sweeAlerts/WarningAlert";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const Remote = () => {
  const {
    handleLearnCodeModal,
    handleEquipmentButtonIconModal,
    setEditEquipmentButton,
    update,
    setButtonShouldLearnCode,
    authUser,
    setIsLoading,
    equipmentButtons,
    setEquipmentButtons,
    devices,
    equipments,
    setEquipments,
    handleEquipmentsListModal,
    setSelectedEquipment,
    setChangeNameOptions,
    handleChangeNameModal,
    currentRoom,
    selectedEquipment,
  } = useContext(Context);
  const { clients } = useContext(MqttContext);
  const [buttons, setButtons] = useState([]);
  const [editButton, setEditButton] = useState(null);
  const [editedButtonName, setEditedButtonName] = useState("");
  const [clickedButtons, setClickedButtons] = useState({});
  const [editEquipmentName, setEditEquipmentName] = useState(false);
  const [editedEquipmentName, setEditedEquipmentName] = useState("");

  const { equipment_id: eq_id, room_id, equipment_type: eq_type } = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    // setIsLoading(true);
    // AllEquipmentButton({
    //   equipment_id: eq_id,
    // }).then(({ data }) => {
    //   setButtons(data.equipment_buttons);
    //   setIsLoading(false);
    // });

    setButtons(
      equipmentButtons
        .filter((eq_btn) => eq_btn.equipment_id == eq_id)
        .map((btn) => ({
          ...btn,
          digit: Number(btn.digit),
        })),
    );
    setSelectedEquipment({
      id: eq_id,
      type: eq_type,
    });
  }, [update, equipmentButtons, eq_id]);

  const handleRemoveButton = (e, button) => {
    setIsLoading(true);
    e.preventDefault();
    DeleteEquipmentButton({
      equipment_button_id: button.id,
    }).then((res) => {
      if (res.status == 200) {
        setEquipmentButtons(equipmentButtons.filter((b) => b.id != button.id));
        SuccessToast("با موفقیت حذف گردید");
        setIsLoading(false);
      }
    });
  };

  const handleChangeNameButton = (button) => {
    const onSubmitFunc = ({ button, name }) => {
      UpdateEquipmentButton({
        equipment_button_id: button.id,
        name: name,
        digit: button.digit,
        icon: button.icon,
      }).then((res) => {
        if (res.status == 200) {
          setEditedButtonName("");
          setEditButton(null);
          SuccessToast("با موفقیت ثبت شد");

          const index = equipmentButtons.findIndex(
            (item) => item.id === button.id,
          );

          if (index !== -1) {
            const updatedButtons = [...equipmentButtons];
            updatedButtons[index] = {
              ...updatedButtons[index],
              name: name,
            };

            setEquipmentButtons(updatedButtons);
          }
        }
      });
    };
    const newOptions = {
      name: button.name,
      onSubmit: (newName) => {
        onSubmitFunc({ button, name: newName });
      },
    };
    setChangeNameOptions(newOptions);
    handleChangeNameModal();
  };

  const concatenateStringAndBuffer = (str, buffer) => {
    let encoder = new TextEncoder();
    let encodedString = encoder.encode(str); // تبدیل رشته به بایت‌ها

    // ساخت یک بافر جدید که به اندازه رشته و بافر اصلی است
    let newBuffer = new Uint8Array(encodedString.length + buffer.byteLength);

    // قرار دادن رشته در ابتدا
    newBuffer.set(encodedString, 0);

    // قرار دادن بافر در ادامه
    newBuffer.set(new Uint8Array(buffer), encodedString.length);

    return newBuffer;
  };

  const handleClickButton = (button) => {
    if (
      button.data1 != null &&
      button.data2 != null &&
      button.data3 != null &&
      button.data4 != null &&
      button.data5 != null
    ) {
      setClickedButtons((prevClicked) => ({
        ...prevClicked,
        [button.id]: true,
      }));
      let device = devices.find((d) => d.id == button.device_id);
      if (!device) {
        return;
      }
      if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
        let buffer = new ArrayBuffer(15);
        let asciiCode = new Uint8Array(buffer);
        asciiCode[0] = 14;
        asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
        asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
        asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
        asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
        asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
        asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
        asciiCode[7] = device.type + 50;
        asciiCode[8] = 1;
        asciiCode[9] = 5;
        asciiCode[10] = button.data1;
        asciiCode[11] = button.data2;
        asciiCode[12] = button.data3;
        asciiCode[13] = button.data4;
        asciiCode[14] = button.data5;

        let message = device.bridge_device.internet_token;

        // ترکیب رشته و بافر
        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

        const messageListener = (topic, message) => {
          const endOfTwoCharToken =
            String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
          const deviceSerial =
            String.fromCharCode(message[3]) +
            String.fromCharCode(message[4]) +
            String.fromCharCode(message[5]) +
            String.fromCharCode(message[6]) +
            String.fromCharCode(message[7]) +
            String.fromCharCode(message[8]);
          if (
            device.bridge_device.internet_token.slice(-2) ===
              endOfTwoCharToken &&
            device.serial === deviceSerial &&
            message[10] == 1 &&
            message[2] == 14
          ) {
            setClickedButtons((prevClicked) => ({
              ...prevClicked,
              [button.id]: false,
            }));
          }
        };

        clients[device.bridge_device.id].removeAllListeners("message");
        clients[device.bridge_device.id].on("message", messageListener);

        // client.on("message", (topic, message) => {
        //   const endOfTwoCharToken =
        //     String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
        //   const deviceSerial =
        //     String.fromCharCode(message[3]) +
        //     String.fromCharCode(message[4]) +
        //     String.fromCharCode(message[5]) +
        //     String.fromCharCode(message[6]) +
        //     String.fromCharCode(message[7]) +
        //     String.fromCharCode(message[8]);
        //   if (
        //     button.device.bridge_device.internet_token.slice(-2) ===
        //       endOfTwoCharToken &&
        //     button.device.serial === deviceSerial &&
        //     message[10] == 1 &&
        //     message[2] == 14
        //   ) {
        //     setClickedButtons((prevClicked) => ({
        //       ...prevClicked,
        //       [button.id]: false,
        //     }));
        //   }
        // });

        clients[device.bridge_device.id].publish(
          device.bridge_device.serial + "/sys",
          combinedMessage,
        );
      } else {
        let buffer = new ArrayBuffer(7);
        let asciiCode = new Uint8Array(buffer);
        asciiCode[0] = 1;
        asciiCode[1] = 5;
        asciiCode[2] = button.data1;
        asciiCode[3] = button.data2;
        asciiCode[4] = button.data3;
        asciiCode[5] = button.data4;
        asciiCode[6] = button.data5;

        let message = device.internet_token;

        // ترکیب رشته و بافر
        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

        const messageListener = (topic, message) => {
          const endOfTwoCharToken =
            String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
          if (
            device.internet_token.slice(-2) === endOfTwoCharToken &&
            message[2] == 1 &&
            message[3] == 0
          ) {
            setClickedButtons((prevClicked) => ({
              ...prevClicked,
              [button.id]: false,
            }));
          }
        };
        clients[device.id].removeAllListeners("message");
        clients[device.id].on("message", messageListener);

        clients[device.id].publish(device.serial + "/sys", combinedMessage);
      }
    } else {
      setButtonShouldLearnCode(button);
      handleLearnCodeModal(true);
    }
  };

  const handleChangeLearnedCodeButton = (button) => {
    setButtonShouldLearnCode(button);
    handleLearnCodeModal(true);
  };

  const handleChangeEquipmentName = (equipment_id) => {
    const onSubmitFunc = ({ equipment_id, name }) => {
      UpdateEquipments({
        equipment_id,
        name,
      }).then((res) => {
        const updatedEquipments = equipments.map((item) =>
          item.id === equipment_id
            ? {
                ...item,
                equipment: { ...item.equipment, name: name },
              }
            : item,
        );
        setEquipments(updatedEquipments);
      });
    };
    const newOptions = {
      name:
        equipments.find((eq) => eq.id == equipment_id)?.equipment.name ?? "",
      onSubmit: (newName) => {
        onSubmitFunc({ equipment_id, name: newName });
      },
    };
    setChangeNameOptions(newOptions);
    handleChangeNameModal();
  };

  const handleRemoveEquipment = (equipment_id) => {
    WarningAlert(
      "آیا از حذف این تجهیز اطمینان دارید؟",
      "",
      "تایید",
      "انصراف",
    ).then(function (result) {
      if (result.value) {
        DeleteEquipments({ equipment_id }).then((res) => {
          SuccessToast(res.data.message);
          let newEquipments = equipments.filter((eq) => eq.id != equipment_id);
          setEquipments(newEquipments);
          let lstEquipment = newEquipments.find(
            (eq) => eq.room_id == currentRoom,
          );
          handleEquipment(lstEquipment, currentRoom);
        });
      }
    });
  };

  const handleEquipment = (equipment, roomId) => {
    if (!equipment) return navigate("/room/" + roomId);
    equipment = equipment.equipment;
    setSelectedEquipment({
      id: equipment.id,
      type: equipment.type,
    });
    if (!equipment) {
      return navigate("/");
    } else if (equipment.type == 1) {
      return navigate(
        "/room/key/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 3) {
      return navigate(
        "/room/remote/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 4) {
      return navigate(
        "/room/dimmer/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 5) {
      return navigate(
        "/room/thermostat/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 9) {
      return navigate(
        "/room/rgb/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 99) {
      return navigate(
        "/room/wireless-key/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 100) {
      return navigate(
        "/room/television/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 501) {
      return navigate(
        "/room/fan-coil/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 401) {
      return navigate(
        "/room/scenario-key/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 503) {
      return navigate(
        "/room/humidity/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 502) {
      return navigate(
        "/room/motor/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 9998) {
      return navigate(
        "/room/input/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 9999) {
      return navigate(
        "/room/input-status/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 600) {
      return navigate(
        "/room/data-logger/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    }
  };

  const renderButtons = () => {
    return buttons.map((button, index) => {
      let device = devices.find((d) => d.id == button.device_id);
      if (!device) {
        return;
      }
      let iconPath = "/assets/img/app-icons/CU.png";
      if (button.icon) {
        let buttonIcon = EquipmentButtonIcons.find(
          (icon) => icon.id == button.icon,
        );
        iconPath = buttonIcon.path;
      }
      return (
        <div
          className="remote-equipment"
          onClick={() => handleClickButton(button)}
          key={index}
        >
          {authUser.is_admin ? (
            <div
              className="btn-group d-inline-block"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <button
                type="button"
                className="btn btn-icon rounded-pill dropdown-toggle hide-arrow"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="bx bx-dots-vertical-rounded"></i>
              </button>
              <ul className="dropdown-menu">
                {button.data1 ||
                button.data2 ||
                button.data3 ||
                button.data4 ? (
                  <li onClick={() => handleChangeLearnedCodeButton(button)}>
                    <a className="dropdown-item">یادگیری مجدد</a>
                  </li>
                ) : null}
                <li
                  onClick={() => {
                    handleEquipmentButtonIconModal(true);
                    setEditEquipmentButton(button);
                  }}
                >
                  <a className="dropdown-item">تغییر آیکون</a>
                </li>
                <li
                  onClick={() => {
                    handleChangeNameButton(button);
                  }}
                >
                  <a className="dropdown-item">تغییر نام</a>
                </li>
                <li onClick={(e) => handleRemoveButton(e, button)}>
                  <a className="dropdown-item">حذف</a>
                </li>
              </ul>
            </div>
          ) : null}

          <div className="icon-part">
            <img src={iconPath} alt="" />
          </div>
          <div
            className={
              clickedButtons[button.id] ? "status-part bg-info" : "status-part"
            }
          ></div>
          <div className="info-part">
            <p
              className={
                editButton == button.id
                  ? "d-none"
                  : "text-center p-0 m-0 d-block"
              }
            >
              {button.name}
            </p>
            <div
              className={editButton == button.id ? "mt-2 d-block" : "d-none"}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <div>
                <input
                  id="smallInput"
                  className="form-control form-control-sm text-center"
                  name="room_name"
                  type="text"
                  placeholder="نام کلید را وارد کنید"
                  value={editedButtonName}
                  onChange={(e) => setEditedButtonName(e.target.value)}
                />
              </div>
              <div className="mt-1">
                <button
                  type="button"
                  className="btn btn-xs btn-success-app submit-add-room me-2"
                  onClick={() => handleChangeNameButton(button)}
                >
                  ثبت
                </button>
                <button
                  type="button"
                  className="btn btn-xs btn-success-app"
                  onClick={(e) => setEditButton(null)}
                >
                  انصراف
                </button>
              </div>
            </div>
            <p className="text-center p-0 m-0" style={{ fontSize: "11px" }}>
              S/{device.serial}
            </p>
          </div>
        </div>
      );
    });
  };

  return (
    <div
      className="card h-100"
      style={{ backgroundColor: "#fff0", boxShadow: "none" }}
    >
      <div
        className="card-header d-flex align-items-center justify-content-between border-bottom mb-3 p-0 pt-2"
        style={{ zIndex: "1" }}
      >
        <h5 className={editEquipmentName ? "d-none" : ""}>
          {equipments.find((eq) => eq.id == eq_id)?.equipment?.name ?? ""}
        </h5>
        <div
          className={editEquipmentName ? "mt-2 d-block" : "d-none"}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <div>
            <input
              id="smallInput"
              className="form-control form-control-sm text-center"
              name="room_name"
              type="text"
              placeholder="نام تجهیز را وارد کنید"
              value={editedEquipmentName}
              onChange={(e) => setEditedEquipmentName(e.target.value)}
            />
          </div>
          <div className="mt-1">
            <button
              type="button"
              className="btn btn-xs btn-success-app submit-add-room me-2"
              onClick={() =>
                handleChangeEquipmentName(
                  equipments.find((eq) => eq.id == eq_id)?.id,
                )
              }
            >
              ثبت
            </button>
            <button
              type="button"
              className="btn btn-xs btn-success-app"
              onClick={(e) => setEditEquipmentName(false)}
            >
              انصراف
            </button>
          </div>
        </div>
        <div>
          {authUser.is_admin ? (
            <>
              <button
                type="button"
                className="btn btn-success-app btn-icon me-2"
                style={{ borderColor: "rgb(0, 165, 148)" }}
                onClick={() => handleRemoveEquipment(selectedEquipment.id)}
              >
                <i className="bx bx-trash"></i>
              </button>
              <div className="btn-group">
                <button
                  type="button"
                  className="btn btn-success-app btn-icon dropdown-toggle hide-arrow"
                  style={{ borderColor: "rgb(0, 165, 148)" }}
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bx bx-dots-vertical-rounded"></i>
                </button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <Link
                      className="dropdown-item"
                      onClick={(e) => {
                        e.preventDefault();
                        handleEquipmentsListModal(true);
                      }}
                    >
                      افزدون تجهیز
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to={
                        "/room/select-device/" +
                        room_id +
                        "/" +
                        eq_id +
                        "/" +
                        eq_type
                      }
                    >
                      افزدون کانال به تجهیز
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      onClick={() =>
                        handleChangeEquipmentName(
                          equipments.find((eq) => eq.id == eq_id)?.id,
                        )
                      }
                    >
                      تغییر نام تجهیز
                    </Link>
                  </li>
                </ul>
              </div>
            </>
          ) : null}

          {/* <BackButton url={"/room/" + room_id} /> */}
        </div>
      </div>
      <div className="card-body scrollbar" style={{ paddingBottom: "10rem" }}>
        {/* <SimpleBar style={{ maxHeight: "100%", padding: "1.5rem" }}> */}
        <div className="d-flex flex-wrap justify-content-between justify-content-sm-start">
          {renderButtons()}
        </div>
        {/* </SimpleBar> */}
      </div>
    </div>
  );
};

export default React.memo(Remote);
